const markerData = [
    //
    // STRATEGY
    // Marian Cramers
    //
    {
        type: 'video',
        barcodeValue: 13,
        title: 'Marian Cramers',

        topline: 'GDL Member',
        subline: 'about the work of the Financial Sustainability Group',
        description: '<p>GDL Member since 2019</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/marian-cramers/#cv-marian-cramers1',
            },
        ],
        video: {
            src: './video/20211118_GDL_Publikation-AugmentedElements_MarianCramers_V3.mp4',
            poster: './video/20211118_GDL_Publikation-AugmentedElements_MarianCramers_V3.jpg',
        },
    },

    //
    // STRATEGY
    // Milica Saracevic
    //
    {
        type: 'video',
        barcodeValue: 12,
        title: 'Milica Saracevic',

        topline: 'GDL Member',
        subline: 'about the work of the Communication Strategy Group',
        description: '<p>GDL Member since 2019</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/milica-saracevic/#cv-milica-saracevic8',
            },
        ],
        video: {
            src: './video/20211118_GDL_Publikation-AugmentedElements_MilicaSaracevic_V3.mp4',
            poster: './video/20211118_GDL_Publikation-AugmentedElements_MilicaSaracevic_V3.jpg',
        },
    },

    //
    // STRATEGY
    // Julia Sattler
    //
    {
        type: 'video',
        barcodeValue: 11,
        title: 'Julia Sattler',

        topline: 'GDL Member',
        subline: 'about the work of the Member Charter Group',
        description: '<p>GDL Member since 2018</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/julia-sattler/#cv-julia-sattler6',
            },
        ],
        video: {
            src: './video/20211118_GDL_Publikation-AugmentedElements_JuliaSattler_V3.mp4',
            poster: './video/20211118_GDL_Publikation-AugmentedElements_JuliaSattler_V3.jpg',
        },
    },

    //
    // STRATEGY
    // Marieke de Wal und Stella Pfisterer
    //
    {
        type: 'video',
        barcodeValue: 14,
        title: 'Marieke de Wal & Stella Pfisterer',

        topline: 'GDL Knowledge Partners',
        subline: 'about the partnership of the PrC and the GDL',
        description: '<p>GDL Knowledge Partners since 2019</p>',
        links: [
            {
                title: 'More about the partnership',
                url: 'https://www.rsm.nl/research/centres/prc/research/projects-new/learning-with-the-global-diplomacy-lab/',
            },
        ],
        video: {
            src: './video/20211118_GDL_Publikation-AugmentedElements_MarikedeWal-StellaPfisterer_V3.mp4',
            poster: './video/20211118_GDL_Publikation-AugmentedElements_MarikedeWal-StellaPfisterer_V3.jpg',
        },
    },

    //
    // LABS
    // CNN Turk Lab Istanbul
    //
    {
        type: 'video',
        barcodeValue: 3,
        title: '2nd Global Diplomacy Lab',
        topline: 'Report',
        subline: 'Istanbul, June 2015',
        description: '<p>Istanbul, June 2015</p><p>Report CNN Turkey</p>',
        links: [
            {
                title: 'Website profile',
                url: 'https://global-diplomacy-lab.org/activities/cnn-report-about-istanbul-lab/',
            },
        ],
        video: {
            src: './video/LABS-Istanbul-CNNTurk.mp4',
            poster: './video/LABS-Istanbul-CNNTurk.jpg',
        },
    },

    //
    // LABS
    // Kyle Matthews
    //
    {
        type: 'video',
        barcodeValue: 4,
        title: 'Kyle Matthews',
        topline: 'GDL member',
        subline: 'about the Lab in Montréal',
        description: '<p>GDL Member since 2016</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/kyle-matthews-/#cv-kyle-matthews2',
            },
        ],
        video: {
            src: './video/LABS-Montreal-Kyle.mp4',
            poster: './video/LABS-Montreal-Kyle.jpg',
        },
    },

    //
    // MEMBERS
    // Banu Pekol
    //
    {
        type: 'video',
        barcodeValue: 9,
        title: 'Banu Pekol',
        topline: 'Elected Advisory Council Member',
        subline: 'Turkey',
        description: '<p>GDL Member since 2017</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/banu-pekol/#cv-banu-pekol5',
            },
        ],
        video: {
            src: './video/MEMBERS-EAC-Banu.mp4',
            poster: './video/MEMBERS-EAC-Banu.jpg',
        },
    },

    //
    // MEMBERS
    // Edna Martinez
    //
    {
        type: 'video',
        barcodeValue: 7,
        title: 'Edna Martinez',
        topline: 'GDL Member',
        subline: 'Mexico',
        description: '<p>GDL Member since 2017</p><p>Summit Working Group</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/edna-elizabeth-martinez-quintanilla/#cv-edna-elizabeth-martinez-quintanilla9',
            },
        ],
        video: {
            src: './video/MEMBERS-Edna-Martinez.mp4',
            poster: './video/MEMBERS-Edna-Martinez.jpg',
            portrait: true,
        },
    },

    //
    // MEMBERS
    // Edna Martinez
    //
    {
        type: 'video',
        barcodeValue: 8,
        title: 'Ankit Khanal',
        topline: 'GDL Member',
        subline: 'Nepal',
        description: '<p>GDL Member since 2019</p><p>Summit Working Group</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/ankit-khanal/#cv-ankit-khanal8',
            },
        ],
        video: {
            src: './video/MEMBERS-Ankit-Khanal.mp4',
            poster: './video/MEMBERS-Ankit-Khanal.jpg',
            portrait: true,
        },
    },

    //
    // STRATEGY
    // Johannes Braun
    //

    {
        type: 'video',
        barcodeValue: 6,
        title: 'Johannes Braun',
        topline: 'GDL Founding Member',
        subline: 'Germany',
        description: '<p>Strategy Working Group</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/johannes-braun/#cv-johannes-braun8',
            },
        ],
        video: {
            src: './video/STRATEGY-Johannes-Braun.mp4',
            poster: './video/STRATEGY-Johannes-Braun.jpg',
            portrait: false,
        },
    },

    //
    // STRATEGY
    // Theresa Carrington
    //
    {
        type: 'video',
        barcodeValue: 5,
        title: 'Theresa Carrington',
        topline: 'GDL Member',
        subline: 'United States',
        description: '<p>GDL Member since 2017</p><p>Strategy Working Group</p>',
        links: [
            {
                title: 'Member profile',
                url: 'https://global-diplomacy-lab.org/members/theresa-carrington/#cv-theresa-carrington10',
            },
        ],
        video: {
            src: './video/STRATEGY-Theresa-Carrington.mp4',
            poster: './video/STRATEGY-Theresa-Carrington.jpg',
            portrait: false,
        },
    },

    //
    // PARTNERS
    // Andrea Christ & Gesa Giesing
    //
    {
        type: 'chat',
        barcodeValue: 10,
        title: 'Andrea Christ & Gesa Giesing',
        topline: 'A conversation between',
        subline: '',
        description: '<p>...</p>',
        links: [],
        participants: [
            {
                name: 'Andrea Christ',
                subline: 'Head of the International Diplomats Training Division at the Federal Foreign Office.',
                image: './images/Andrea-Christ.jpg',
            },
            {
                name: 'Gesa Giesing',
                subline:
                    'Programme manager "Networked Diplomacy: Alumni and Partners" and responsible for maintaining the networks and alumni.',
                image: './images/Gesa-Giesing.jpg',
            },
        ],
        messages: [
            {
                participant: 0,
                text: '',
                meta: 'Voice Message 00:34',
                audio: {
                    src: './audio/01-Andrea-Christ.mp3',
                },
            },
            {
                participant: 1,
                text: '',
                meta: 'Voice Message 01:06',
                audio: {
                    src: './audio/02-Gesa-Giesing.mp3',
                },
            },
            {
                participant: 0,
                text: '',
                meta: 'Voice Message 01:03',
                audio: {
                    src: './audio/03-Andrea-Christ.mp3',
                },
            },
            {
                participant: 1,
                text: '',
                meta: 'Voice Message 00:39',
                audio: {
                    src: './audio/04-Gesa-Giesing.mp3',
                },
            },
            {
                participant: 0,
                text: '',
                meta: 'Voice Message 01:36',
                audio: {
                    src: './audio/05-Andrea-Christ.mp3',
                },
            },
        ],
    },

    //
    // ACTIVITY
    // Twitter
    //
    {
        type: 'link',
        barcodeValue: 1,
        title: 'GDL on Twitter',
        topline: 'Follow',
        subline: '',
        link: {
            poster: './images/link-preview--twitter.jpg',
            url: 'https://twitter.com/diplomacy_lab',
        },
    },

    //
    // ACTIVITY
    // Gender Alliance
    //
    {
        type: 'link',
        barcodeValue: 2,
        title: 'Gender Alliance',
        topline: '',
        subline: '',
        link: {
            poster: './images/link-preview--gender-alliance.jpg',
            url: 'https://thegenderalliance.com',
        },
    },
];

export default markerData;
